import { PortfolioDto } from '../interfaces/portfolio.dto';

/** What a seat holds that changes hands when it leaves the company. */
export interface SeatHoldings {
  managedUnitCount: number;
  ownedPortfolios: Pick<PortfolioDto, 'id' | 'name' | 'unitCount'>[];
  collaboratingPortfolioCount: number;
  /** The unit list read was one page of a longer one, so the count is a floor */
  isPartial: boolean;
}

/**
 * Worked out from the property list and the portfolios the app already reads, so the removal can
 * say what moves without its own request.
 */
export function seatHoldings(
  investorId: string,
  units: { manager?: { investorId: string } | null }[],
  portfolios: PortfolioDto[],
  isPartial = false,
): SeatHoldings {
  return {
    managedUnitCount: units.filter((unit) => unit.manager?.investorId === investorId).length,
    ownedPortfolios: portfolios
      .filter((portfolio) => portfolio.ownerId === investorId)
      .map(({ id, name, unitCount }) => ({ id, name, unitCount })),
    collaboratingPortfolioCount: portfolios.filter((portfolio) =>
      portfolio.collaborators.some((collaborator) => collaborator.investorId === investorId),
    ).length,
    isPartial,
  };
}
